import { Vector3 } from 'three';
import ObjectView from '@scene/views/object-view';
import Axis from '@scene/axis';
import { PerspectiveCameraTypes } from '../actions';

export const SafetyBarrierPerspective = {
  Edge_slab: {
    perspectiveCamera: {
      position: new Vector3(1750, 1600, 1500),
      target: new Vector3(0, 0, 0),
    },
    basePlateCamera: {
      position: new Vector3(950, 600, 700),
      target: new Vector3(0, 200, 0)
    }
  },
  Floor_slab: {
    perspectiveCamera: {
      position: new Vector3(1750, 1600, 1500),
      target: new Vector3(0, 150, 0),
    },
    basePlateCamera: {
      position: new Vector3(750, 1100, 400),
      target: new Vector3(0, 200, 0)
    }
  },
  Pedestal: {
    perspectiveCamera: {
      position: new Vector3(1750, 1600, 1500),
      target: new Vector3(125, 500, 0),
    },
    internalPerspectiveCamera: {
      position: new Vector3(-1750, 1600, -1500),
      target: new Vector3(125, 500, 0),
    },
    basePlateCamera: {
      position: new Vector3(750, 1200, 300),
      target: new Vector3(0, 200, -100)
    },
    externalBasePlateCamera: {
      position: new Vector3(1050, 900, 600),
      target: new Vector3(-50, 400, -200)
    },
    internalBasePlateCamera: {
      position: new Vector3(-650, 850, -700),
      target: new Vector3(50, 350, -50)
    }
  },
  Stairs: {
    perspectiveCamera: {
      position: new Vector3(3000, 3000, 3000),
      target: new Vector3(750, 300, -200)
    },
    basePlateCamera: {
      position: new Vector3(2100, 600, 550),
      target: new Vector3(650, 350, -125)
    },
    topBasePlateCamera: {
      position: new Vector3(1550, 1300, 500),
      target: new Vector3(800, 250, -50)
    }
  },
  Between_Walls: {
    perspectiveCamera: {
      position: new Vector3(2000, 800, 800),
      target: new Vector3(-120, -50, 160),
    },
    basePlateCamera: {
      position: new Vector3(575, 625, 300),
      target: new Vector3(50, 550, -250)
    }
  }
};

export default {
  mode: ObjectView.mode.MODE_3D,
  orthographicCamera: {
    position: new Vector3(0.0007121568184116151, 712.1446482277966, -0.000005268009116589875),
    zoom: 10
  },
  perspectiveCamera: {
    // position: new Vector3(1233.155205098752, 583.6301617646784, 1070.9073620997535),
    // target: new Vector3(-119.40571042507372, -58.57418667458079, 160.1425455722851),
    position: SafetyBarrierPerspective.Edge_slab.perspectiveCamera.position,//new Vector3(2500, 800, 2000),
    target: new Vector3(-120, 100, 160),
    zoom: 1
  },
  axis: {
    position: null,
    orientation3D: Axis.types.Y_TOP,
    orientation2D: Axis.types.Y_TOP_2D
  },
  perspectiveCameraType: PerspectiveCameraTypes.zoom_out
};



// WEBPACK FOOTER //
// ./src/reducers/camera/defaults/safetyBarrier.js